import { PdfPreviewZoomBar } from "./PdfPreviewZoomBar";

export default PdfPreviewZoomBar;